import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ControlValueAccessor, FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select';
import { RemindersApiService } from 'src/app/services/reminders-api.service';
import { Reminder } from 'src/app/models/reminder';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FrequencyType, Hour } from 'src/app/models/FrequencyType.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { User } from 'src/app/models/user.model';
import { GlobalStore } from 'src/app/store/global-store';


@Component({
    selector: 'que-create-reminder',
    imports: [CommonModule, TranslateDirective, TranslatePipe, MatFormFieldModule, MatInputModule,
        MatButtonModule, MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatCheckboxModule, ReactiveFormsModule, FormsModule],
    templateUrl: './create-reminder.component.html',
    styleUrls: ['./create-reminder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateReminderComponent implements ControlValueAccessor, OnInit {
  @Input()
  users: User[] = [];
  @Output()
  closeEvent = new EventEmitter<number>();
  @Output()
  createEvent = new EventEmitter<Reminder>();
  #reminderApi = inject(RemindersApiService);
  #globalStore = inject(GlobalStore);
  maxOptionsToShow = 4;

  frequency$ = this.#globalStore.frequency$;
  hourers$ = this.#globalStore.houers$;

  #builder = inject(FormBuilder);
  reminderForm = this.#builder.group({
    content: new FormControl<string>(''),
    startDate: new FormControl<Date | null>(new Date(), [Validators.required]),
    hour: new FormControl<number>(10),
    frequencyId: new FormControl<number | null>(1),
    endDate: new FormControl<Date | null>(null),
    isApproval: new FormControl<boolean>(false)
  });

  registerOnChangeCallback: any = () => { };

  ngOnInit() {
    this.reminderForm.valueChanges.subscribe(
      group => {
        if (this.registerOnChangeCallback)
          this.registerOnChangeCallback(group)
      }

    )
  }
  writeValue(obj: any): void {
    this.reminderForm.setValue(obj, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.reminderForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  save() {
    //, recipients: this.users 
    this.createEvent.emit({ ...this.reminderForm.value, id: 0 } as Reminder);
  }
  deletUser(user: User) {
    this.users = this.users.filter(u => u.firstName != user.firstName || u.lastName != user.lastName || u.email != user.email)
  }
  cancel() {
    this.closeEvent.emit(1);
  }
  appproval() {
    this.reminderForm.controls.isApproval.setValue(!this.reminderForm.controls.isApproval.value)
  }
}
